import { Routes, Route, useLocation } from 'react-router-dom'
import React from 'react'
/** Pages */
import Login from '@pages/Login'

const AuthRoutes = () => {
	// if route is not found, redirect to login
    const location = useLocation()
	
    if (location.pathname !== '/login') {
        window.location.href = '/login'
    }
	return (
		<Routes>
			<Route path="/login" element={<Login />} />
		</Routes>
	)
}

export default AuthRoutes
